import api from "../lib/api";

export const getStates = () => api.get("/api/court/get-states");

export const createHighCourt = (payload: any) =>
  api.post("/api/court/create-highcourt", payload);
export const updateHighCourt = (payload: any) =>
  api.post("/api/court/update-highcourt", payload);
export const getHighCourt = () => api.get("/api/court/get-highcourt");
export const deleteHighCourt = (payload: any) =>
  api.post("/api/court/delete-highcourt", payload);

// Benches and Subordinate Courts
export const createBench = (payload: any) =>
  api.post("/api/court/create-bench", payload);

export const updateBench = (payload: any) =>
  api.post("/api/court/update-bench", payload);

export const deleteBench = (payload: any) =>
  api.post("/api/court/delete-bench", payload);

export const getBenches = (highcourt: string) =>
  api.post("/api/court/get-benches", { highcourt });

// Bench Rooms
export const createBenchRoom = (payload: any) =>
  api.post("/api/court/create-bench-room", payload);

export const updateBenchRoom = (payload: any) =>
  api.post("/api/court/update-bench-room", payload);

export const getBenchRooms = (bench: string) =>
  api.post("/api/court/get-bench-rooms", { bench });

export const deleteBenchRoom = (payload: any) =>
  api.post("/api/court/delete-bench-room", payload);

// Districts
export const createDistrict = (payload: any) =>
  api.post("/api/court/create-district", payload);

export const updateDistrict = (payload: any) =>
  api.post("/api/court/update-district", payload);

export const deleteDistrict = (payload: any) =>
  api.post("/api/court/delete-district", payload);

export const getDistricts = (highcourt: string) =>
  api.post("/api/court/get-districts", { highcourt });

// Complexes
export const createComplex = (payload: any) =>
  api.post("/api/court/create-complex", payload);

export const updateComplex = (payload: any) =>
  api.post("/api/court/update-complex", payload);

export const deleteComplex = (payload: any) =>
  api.post("/api/court/delete-complex", payload);

export const getComplexes = (district: string) =>
  api.post("/api/court/get-complexes", { district });

// Establishments
export const createEstablishment = (payload: any) =>
  api.post("/api/court/create-establishment", payload);

export const updateEstablishment = (payload: any) =>
  api.put("/api/court/update-establishment", payload);

export const getEstablishments = (complex: string) =>
  api.get(`/api/court/get-establishments/${complex}`);

export const deleteEstablishment = (payload: any) =>
  api.post("/api/court/delete-establishment", payload);

// Court Rooms
export const createCourtRoom = (payload: any) =>
  api.post("/api/court/create-courtroom", payload);

export const updateCourtRoom = (payload: any) =>
  api.post("/api/court/update-courtroom", payload);

export const getCourtRooms = (complex: string) =>
  api.get(`/api/court/get-courtrooms/${complex}`);

export const deleteCourtRoom = (payload: any) =>
  api.post("/api/court/delete-courtroom", payload);
